module.exports = __webpack_public_path__ + "static/img/9.2ce0df4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/9.png
// module id = eeq5
// module chunks = 0